import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import MainPagetitle from '../../../layouts/MainPagetitle';
import ActionRemarks from '../Grievance/components/ActionRemarks';
import ActivityLogs from '../Grievance/components/ActivityLogs';
import ComplaintDetails from '../Grievance/components/ComplaintDetails';
import GrievanceHeaderInfo from '../Grievance/components/GrievanceHeaderInfo';
import GrievanceProcessProgress from '../Grievance/components/GrievanceProcessProgress';
import ResolutionBlock from '../Grievance/components/ResolutionBlock';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '../../../../utils/redux/store';
import { useEffect, useState } from 'react';
import moment from 'moment';

const MyComplaintsView = (props) => {
  const isReadonly = props.urlparams.params.readonly === 'true' ? true : false;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const viewType = searchParams.get('type') || 'general'; // 'assigned', 'general', 'escalated', 'customer'

  const [complaintData, setComplaintData] = useState({});

  // Derived states based on context
  const showPreviousResolution = viewType === 'escalated';

  const handleReopen = (e) => {
    e.preventDefault();
    swal2
      .fire({
        title:
          'Are you sure want to reopen this complaint? \n If yes please provide the reason for it.',
        icon: 'info',
        iconColor: '#DE3232',
        html: '<div id="reopenreason-container"></div>',
        showCancelButton: true,
        confirmButtonColor: '#DE3232',
        cancelButtonColor: '##D6DBE7',
        confirmButtonText: 'Submit & Reopen Complaint',
        cancelButtonText: 'No',
        customClass: {
          htmlContainer: 'rejected_html_container',
          actions: 'rejected_actions',
        },
        preConfirm: async () => {
          let reopenRemarks = document.querySelector('#reopenreason').value;
          if (!reopenRemarks) {
            toast.error('Please provide reason for reopening');
            return false;
          }
          return reopenRemarks;
        },
      })
      .then((result) => {
        console.log({ result });
        if (result.isConfirmed) {
          let reopenRemarks = result.value;
          let payload = {
            remarks: reopenRemarks,
            status: _enum.COMPLAINT_STATUS_MAP.REOPENED,
          };
          console.log({ payload });
          props.apis
            .apiUpdateComplaintById(payload, { id: complaintData?.complaintId })
            .then((res) => {
              if (res) {
                console.log(res);
                toast.success('Complaint reopened successfully.');
                navigate('/app/mycomplaints');
              }
            });
        }
      });
    let container = document.getElementById('reopenreason-container');
    let root = createRoot(container);
    root.render(
      <Provider store={store}>
        <AppInput
          id="reopenreason"
          name="remarks"
          label="Reason"
          placeholder="Please describe the reason for reopening"
          type="textarea"
          rows={4}
          required={true}
        ></AppInput>
      </Provider>
    );
  };

  const handleAcceptCloseComplaint = () => {
    swal2
      .fire({
        title: 'Are you sure want to Accept & Close Complaint?',
        icon: 'warning',
        iconColor: '#FF4D4D',
        showCancelButton: true,
        confirmButtonColor: '#FF4D4D',
        cancelButtonColor: '##D6DBE7',
        confirmButtonText: 'Yes, Accept & Close',
      })
      .then((result) => {
        if (result.isConfirmed) {
          let payload = {
            status: _enum.COMPLAINT_STATUS_MAP.CLOSED,
          };
          props.apis
            .apiUpdateComplaintById(payload, { id: complaintData?.complaintId })
            .then((res) => {
              if (res) {
                toast.success('Complaint closed successfully.');
                navigate('/app/mycomplaints');
              }
            });
        }
      });
  };

  const getBreadCums = () => {
    let pagetitle = complaintData?.complaintNumber || props?.urlparams?.params?.id || '';
    return pagetitle;
  };

  useEffect(() => {
    if (props?.urlparams?.params?.id) {
      props.apis.apiGetComplaintById({ id: props?.urlparams?.params?.id }).then((res) => {
        setComplaintData(res || {});
      });
    }
  }, []);

  const getAssignedTo = () => {
    if (complaintData?.assignedGrievanceStaff?.name) {
      return `${complaintData.assignedGrievanceStaff.name} (Grievance Officer)`;
    }
    if (complaintData?.assignedComplianceOfficer?.name) {
      return `${complaintData.assignedComplianceOfficer.name} (Compliance Officer)`;
    }
    if (complaintData?.assignedNodalOfficer?.name) {
      return `${complaintData.assignedNodalOfficer.name} (Nodal Officer)`;
    }
    if (complaintData?.assignedDataEntry?.name) {
      return `${complaintData.assignedDataEntry.name} (Data Entry)`;
    }
    return '-';
  };

  const getProgressStatus = (status) => {
    if (!status) return 'Logged';
    const s = status.toUpperCase();
    if (s === 'LOGGED') return 'Logged';
    if (s === 'ASSIGNED') return 'Assigned';
    if (s === 'IN_PROGRESS' || s === 'IN PROGRESS') return 'In Progress';
    if (s === 'RESOLVED') return 'Resolved';
    if (s === 'CLOSED') return 'Closed';
    return status.toTitleCase();
  };

  const headerInfoProps = {
    grievanceId: complaintData?.complaintNumber || complaintData?.complaintId || '-',
    type: complaintData?.queryType || '-',
    receivedOn: complaintData?.createdAt
      ? moment(complaintData.createdAt).format('DD-MM-YYYY, hh:mm A')
      : '-',
    escalatedOn: complaintData?.escalatedToGrievanceAt
      ? moment(complaintData.escalatedToGrievanceAt).format('DD-MM-YYYY, hh:mm A')
      : null,
    sla: complaintData?.slaText || null,
    customerName: complaintData?.customerName || '-',
    customerPhone: complaintData?.mobileNumber || '-',
    customerLan: complaintData?.loanAccountNumber || '-',
    assignedTo: getAssignedTo(),
    previouslyAssignedTo:
      complaintData?.previousComplianceOfficer && complaintData.previousComplianceOfficer !== '-'
        ? complaintData.previousComplianceOfficer
        : null,
    assignedOn: complaintData?.assignedAt
      ? moment(complaintData.assignedAt).format('DD-MM-YYYY, hh:mm A')
      : null,
    currentStage: complaintData?.status ? complaintData.status.toTitleCase() : '-',
    pdfUrl: null,
  };

  const complaintDetailsProps = {
    category:
      _enum?.CATEGORY_OF_SERVICE_LIST_REVERSE_MAP?.[complaintData?.categoryOfService] ||
      complaintData?.categoryOfService ||
      '-',
    title: complaintData?.complaintTitle || '-',
    explanation: complaintData?.complaintExplanation || '-',
    attachments: complaintData?.attachments || [],
  };

  const mappedLogs = (complaintData?.logs || [])
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .map((log) => ({
      ...log,
      timestamp: log?.createdAt ? moment(log.createdAt).format('DD MMM YYYY, hh:mm A') : '-',
      actionType: log?.actionType || '-',
      actionBy: log?.actionByName || log?.actionBy || '-',
      actionDetails: log?.actionDetails || '-',
    }));

  return (
    <>
      <MainPagetitle
        mainTitle="My Complaints"
        back={getBreadCums()}
        backLink="/app/mycomplaints"
        pageIcon={imagepaths.GrievanceIconActive}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <GrievanceHeaderInfo {...headerInfoProps} />
          </div>
        </div>

        <div className="row g-3">
          {/* Grievance Process Progress */}
          {complaintData?.queryType === _enum.COMPLAINT_QUERY_TYPE_MAP.GENERAL && (
            <div className="col-xl-4 col-lg-5">
              <GrievanceProcessProgress currentStatus={getProgressStatus(complaintData?.status)} />
            </div>
          )}

          <div
            className={
              complaintData?.queryType === _enum.COMPLAINT_QUERY_TYPE_MAP.GENERAL
                ? 'col-xl-8 col-lg-7'
                : 'col-12'
            }
          >
            {/* Complaint Details */}
            <ComplaintDetails details={complaintDetailsProps} readonly={isReadonly} />
          </div>

          <div className="col-12">
            {/* Resolution Provided */}
            {showPreviousResolution && (
              <ResolutionBlock
                title="Previous Resolution (By Compliance Officer)"
                resolutionText={
                  complaintData?.previousComplianceOfficer &&
                  complaintData?.previousComplianceOfficer !== '-'
                    ? complaintData.previousComplianceOfficer
                    : 'No resolution provided before SLA breached'
                }
                description="The complaint has been escalated to you for review and resolution."
              />
            )}
            {complaintData?.resolutionRemark && (
              <ResolutionBlock
                title="Resolution Provided"
                description={complaintData?.resolutionRemark}
                resolvedBy={
                  complaintData?.assignedGrievanceStaff?.name ||
                  complaintData?.assignedComplianceOfficer?.name ||
                  'Grievance Officer'
                }
                resolutionDate={
                  complaintData?.updatedAt
                    ? moment(complaintData.updatedAt).format('DD-MM-YYYY, hh:mm A')
                    : ''
                }
              />
            )}

            {/* Comment */}
            {complaintData?.queryType === _enum.COMPLAINT_QUERY_TYPE_MAP.COMPLAINCE && (
              <ActionRemarks
                label={viewType === 'general' ? 'Comment' : 'Resolution Remarks *'}
                placeholder="Please enter"
                buttons={
                  viewType === 'general'
                    ? [
                        { label: 'Close', className: 'btn-danger light' },
                        { label: 'Save', className: 'btn-primary' },
                      ]
                    : [
                        { label: 'Save As Draft', className: 'btn-danger light' },
                        { label: 'Submit Resolution', className: 'btn-primary' },
                      ]
                }
              />
            )}

            {/* Activity Logs */}
            <ActivityLogs logs={mappedLogs} />

            {!isReadonly && (
              <div className="d-flex justify-content-end gap-3 mb-4">
                {complaintData?.status !== _enum.COMPLAINT_STATUS_MAP.REOPENED && (
                  <button className="btn btn-danger light" onClick={(e) => handleReopen(e)}>
                    Reopen Complaint
                  </button>
                )}
                {complaintData?.status !== _enum.COMPLAINT_STATUS_MAP.CLOSED && (
                  <button className="btn btn-primary" onClick={() => handleAcceptCloseComplaint()}>
                    Accept & Close Complaint
                  </button>
                )}
                <div className="nav_container">
                  <Link to={`/app/mycomplaints`} className="btn btn-primary-lite me-3">
                    Close
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(MyComplaintsView);
